import { mapActions, mapGetters, mapMutations } from 'vuex'
import { CustomInputs } from '@/components/inputs'
import Comments from '@/components/Comments'
import DiscussionPoints from '@/components/DiscussionPoints'
import { prefixedField } from '@/_helpers/utils'

export default {
  components: {
    ...CustomInputs,
    Comments,
    DiscussionPoints,
  },
  beforeDestroy()
  {
    this.onSubmit()
  },
  computed: {
    ...mapGetters('currentConsult', [
      'getFieldValue',
      'getFieldComment',
      'seasonStartYear',
      'isReadOnly',
      'currentComponent',
    ]),
    FARMS: function ()
    {
      return this.getFieldValue('FARMS', this.$options.name) || []
    },
  },
  methods: {
    ...mapMutations('currentConsult', [
      'completeStep',
      'visitStep',
      'setEmailNotification',
    ]),
    ...mapActions('currentConsult', [
      'setFieldValue',
      'updateCurrentModel',
    ]),
    checkAndCompleteStep: function ()
    {
      if (this.validate)
      {
        this.completeStep({stepSlug: this.$options.name, isComplete: this.validate()})
      }
    },
    onSubmit: function() {
      if (this.toggleNotifications)
      {
        this.toggleNotifications()
      }

      this.checkAndCompleteStep()

      return new Promise((resolve) => { return resolve() })
    },
    widthForRow(farms) {
      return farms.length * 400;
    },
    getChartData: function(fieldName, modelName) {
      return (this.getFieldValue('CHARTS', modelName) || {})[fieldName]
    },
    getRowClass: function(items, key, index) {
      if (index == 0) {
        this.lastRowClass = 'colored-table-row'
        return 'colored-table-row'
      }
      let lastItemSeason = this.getRowSeason(items[index-1][key])
      let currentItemSeason = this.getRowSeason(items[index][key])

      if (lastItemSeason != currentItemSeason) {
        if (this.lastRowClass == 'colored-table-row') {
          this.lastRowClass = ''
        } else {
          this.lastRowClass = 'colored-table-row'
        }
      }
      return this.lastRowClass
    },
    getRowSeason: function(str) {
      return str.substring(str.length - 4)
    },
    prefixedField: prefixedField,
  },
};
